import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import Login from '@/views/Login.vue'
import RequestLoginData from '@/views/RequestLoginData.vue'
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'
import { API } from "@/api.js";

const jwt = require("jsonwebtoken");

Vue.use(VueRouter)
Vue.component('v-icon', Icon)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/rld',
    name: 'RequestLoginData',
    component: RequestLoginData
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/billofmaterials',
    name: 'BillOfMaterials',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "billofmaterials" */ '../views/BillOfMaterials.vue')
  },
  {
    path: '/rfq',
    name: 'RFQ',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "rfq" */ '../views/RFQ.vue')
  },
  {
    path: '/machines',
    name: 'Machines',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "machines" */ '../views/Machines.vue')
  },
  {
    path: '/infomacchina',
    name: 'MachineInfo',
    component: () => import(/* webpackChunkName: "machineinfo" */ '../views/InfoMacchina.vue')
  },
  {
    path: '/tickets',
    name: 'Tickets',
    component: () => import(/* webpackChunkName: "tickets" */ '../views/Tickets.vue')
  },
  {
    path: '/spareparts',
    name: 'SpareParts',
    component: () => import(/* webpackChunkName: "spareparts" */ '../views/SpareParts.vue')
  },
  {
    path: '/assistance',
    name: 'Assistance',
    component: () => import(/* webpackChunkName: "spareparts" */ '../views/Assistance.vue')
  },
  {
    path: '/repairs',
    name: 'Repairs',
    component: () => import(/* webpackChunkName: "spareparts" */ '../views/Repairs.vue')
  },
  {
    path: '/reminders',
    name: 'Reminders',
    component: () => import(/* webpackChunkName: "spareparts" */ '../views/Reminders.vue')
  },
  {
    path: '/contracts',
    name: 'Contracts',
    component: () => import(/* webpackChunkName: "contracts" */ '../views/Contracts.vue')
  },
  {
    path: '/arch',
    name: 'News',
    component: () => import(/* webpackChunkName: "news" */ '../views/News.vue')
  },
  {
    path: '/users',
    name: 'Users',
    props: { table: 'users' },
    component: () => import(/* webpackChunkName: "users" */ '../views/Tabella.vue')
  },
  {
    path: '/siteadmin',
    name: 'SiteAdmin',
    props: { table: 'users' },
    component: () => import(/* webpackChunkName: "siteadmin" */ '../views/SiteAdmin.vue')
  },
  {
    path: '/logs',
    name: 'Logs',
    props: { url: 'report.html' },
    component: () => import(/* webpackChunkName: "logs" */ '../views/IFrame.vue')
  },
  {
    path: '/logs2',
    name: 'Logs2',
    props: { table: 'logs' },
    component: () => import(/* webpackChunkName: "logs" */ '../views/Logs2.vue')
  },
  {
    path: '/overrides',
    name: 'Overrides',
    props: { table: 'possible_units' },
    component: () => import(/* webpackChunkName: "overrides" */ '../views/Tabella.vue')
  },
  {
    path: '/support',
    name: 'Support',
    component: () => import(/* webpackChunkName: "support" */ '../views/Support.vue')
  },
]

const router = new VueRouter({
  routes
})

// verifico il token
// eslint-disable-next-line no-unused-vars
router.beforeEach((to, from,next) => {
	if(to.name!='Login' && to.name!='Home' && to.name!='RequestLoginData') {
		let token = localStorage.getItem("jwt");
		console.log("token", token);
		if (token) {
            try {
                API.navlog(to.name)
            } catch (error) {
                console.error("NAV",error)
            }
			try {
				// qui non ho la chiave "secret" e non voglio averla. Mi interessa solo sapere se il token
				// è scaduto in modo tale da non provare ad utilizzarlo per niente (tanto poi le API lo rifiuterebbero)
				const { exp } = jwt.decode(token);
                const now = (new Date().getTime() + 1) / 1000
                console.log("payload:",exp - now)
                if (exp < now) {
					console.log("token scaduto")
					localStorage.removeItem("jwt");
					next ({ name: 'Home' })
				} else {
					next()
				}
			} catch (error) {
				console.log("Token not valid");
				localStorage.removeItem("jwt");
				next ({ name: 'Home' })
			}
		} else {
			console.log("goto home !")
			next ({ name: 'Home' })
		}
	} else {
		next()
	}
})
export default router
